import {useQuery} from '@tanstack/react-query';
import {api} from '../services/api';

/**
 * Server answers for the financial actions (backend GET /auth/capabilities, doc 40 §4.2): the route permission of each
 * action evaluated by the server for this user and the tenant's authorization model. Buttons use `allowed` and show
 * `reason`; the server decides again on every request (activation, period, document state).
 */
export type Capability={allowed:boolean;reason:string|null};
export type Capabilities={authorizationModel:'LEGACY'|'RBAC';actions:Record<string,Capability>};

const LOADING:Capability={allowed:false,reason:'Checking permissions…'};

export function useCapabilities(userKey:string|null){
 const q=useQuery({queryKey:['capabilities',userKey],enabled:!!userKey,queryFn:({signal})=>api<Capabilities>('/auth/capabilities',{signal}),staleTime:60_000});
 const cap=(key:string):Capability=>q.data?.actions[key]??(q.isError?{allowed:false,reason:'Permissions could not be loaded; reload the page.'}:LOADING);
 return {cap,model:q.data?.authorizationModel,loaded:!!q.data};
}
